<template>
  <BreadCrumb PageTitle="Account Settings" />
  <CoverImage />
  <BankSettings />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import CoverImage from "../../components/Generals/CoverImage.vue";
import BankSettings from "../../components/Generals/AccountSettings/BankSettings.vue";

export default defineComponent({
  name: "BanksPage",
  components: {
    BreadCrumb,
    CoverImage,
    BankSettings,
  },
});
</script>